export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/referral_program_perseus/credit.63c5347.svg";